import { IUserData } from 'Foundation/User/UserContextModels';
import { GetMarketingInitiatives } from 'Foundation/User/UserApi';
import { unformatPhone } from 'Utilities/StringFormatter';
import { CookieHandler } from 'Utilities/CookieHandler';

type ChatUIPayloadBase = {
  agencyName: string;
  agentName: string;
  agentEmail: string;
  agentPhone: string;
  pingUserToken: string;
  userId: string;
  userType: string;
  isMocking: boolean;
  mockedUserId: string | null;
};

type ChatUIPayloadPL = ChatUIPayloadBase & {
  statCode: string;
  masterStatCode: string;
  goldStatus: string;
};

type ChatUIPayloadSC = ChatUIPayloadBase & {
  eCliqCodes: string;
  rampCode: string;
  subCode: string;
  marketingInitiatives: string;
};

export const getChatUIPayloadPL = (userData: IUserData): ChatUIPayloadPL | void => {
  const userTokenCookieName = 'sitecore-jwt';
  try {
      if (userData) {
      const chatUIPayload: ChatUIPayloadPL = {
        agencyName: userData.selectedStatCodeData?.AgencyName ?? '',
        agentName: userData.name ?? '',
        statCode: userData.selectedStatCodeData?.SubStat ?? '',
        masterStatCode: userData.selectedStatCodeData?.Master ?? '',
        agentEmail: userData.dpecEmail ?? '',
        agentPhone: userData.selectedStatCodeData?.AgencyContactPhone
          ? (unformatPhone(userData.selectedStatCodeData?.AgencyContactPhone) ??
            userData.selectedStatCodeData?.AgencyContactPhone)
          : '',
        goldStatus: mapGoldStatus(userData.selectedStatCodeData?.AgencyServicingTypeCode) ?? '',
        pingUserToken: CookieHandler.getCookieByName(userTokenCookieName) ?? '',
        userId: userData?.userIdNoAuthSuffix() ?? '',
        userType: userData.userType ?? '',
        isMocking: userData.isMockingAgent ?? false,
        mockedUserId: userData.isMockingAgent ? (userData.dpecid ?? '') : '',
      };

      return chatUIPayload ?? ({} as ChatUIPayloadPL);
    } else {
      console.error(
        `Failure in ChatUI.getChatUIPayloadPL(): Failed to populate chatUIPayload because userData is: ${JSON.stringify(
          userData,
        )}`,
      );
    }
  } catch (err: any) {
    console.error(`Error in ChatUI.getChatUIPayloadPL(): ${err.message}`);
    if (userData) console.log(`userData: ${JSON.stringify(userData)}`);
  }
};

export const getChatUIPayloadSC = async (userData: IUserData): Promise<ChatUIPayloadSC | void> => {
  const userTokenCookieName = 'sitecore-jwt-sc';
  
  let agentMarketingInitiatives = await GetMarketingInitiatives();
  if (agentMarketingInitiatives === null || agentMarketingInitiatives === undefined || agentMarketingInitiatives.length === 0)
    agentMarketingInitiatives = [];

  try {
    if (userData) {
      const chatUIPayload: ChatUIPayloadSC = {
        agencyName: userData.selectedStatCodeData?.AgencyName ?? '',
        agentName: userData.name ?? '',
        eCliqCodes: userData.eCliqCodes ? JSON.stringify(userData.eCliqCodes) : '',
        rampCode: userData.selectedStatCodeData?.Master ?? '',
        subCode: userData.selectedStatCodeData?.SubStat ?? '',
        agentEmail: userData.email ?? '',
        agentPhone:
          userData.phoneList && userData.phoneList.length > 0
            ? (unformatPhone(
                userData.phoneList.filter((phone) => phone.PhoneTypeCode.toLowerCase() === 'bus')[0]?.PhoneNumber,
              ) ?? userData.phoneList[0]?.PhoneNumber)
            : '',
        pingUserToken: CookieHandler.getCookieByName(userTokenCookieName) ?? '',
        userId: userData?.userIdNoAuthSuffix() ?? '',
        userType: userData.userType ?? '',
        isMocking: userData.isMockingAgent ?? false,
        mockedUserId: userData.isMockingAgent ? (userData.dpecid ?? '') : '',
        marketingInitiatives: agentMarketingInitiatives ? JSON.stringify(agentMarketingInitiatives) : '',
      };

      if (chatUIPayload)
        return chatUIPayload
      else
        return {} as ChatUIPayloadSC;
    } else {
      console.error(
        `Failure in ChatUI.getChatUIPayloadSC(): Failed to populate chatUIPayload because userData is: ${JSON.stringify(
          userData,
        )}`,
      );
    }
  } catch (err: any) {
    console.error(`Error in ChatUI.getChatUIPayloadSC(): ${err.message}`);
    if (userData) console.log(`userData: ${JSON.stringify(userData)}`);
  }
};

const mapGoldStatus = (goldStatusInput: string): string => {
  try {
    if (goldStatusInput) {
      let goldStatus = goldStatusInput?.toLowerCase();
      if (goldStatus === 'gold' || goldStatus === 'gold plus (platform only)') return 'gold';
      else if (goldStatus === 'gxh' || goldStatus === 'ag') return 'non-gold';
      else console.log(`ChatUI.mapGoldStatus(): goldStatusInput is: ${goldStatusInput}, returning empty string`);
    } else console.log('ChatUI.mapGoldStatus(): goldStatusInput is undefined, returning empty string');
  } catch (err: any) {
    console.error(`Error in ChatUI.mapGoldStatus(): ${err.message}`);
  }
  return '';
};
